import { styled } from "@glitz/react";
import { spacing, Theme } from "../theme";
import Button from "./basic/Button";
import CheckoutCart from "./CheckoutCart";
import { useCreateOrder } from "../api/orders.api";
import { useCart } from "../context/CartContext";
import Summery from "./Summary";
import DiscountSection from "./DiscountSection";

interface OrderSummaryProps {
  onOrderCreated: (data: {
    orderId: number | string;
    orderNumber?: string;
  }) => void;
  onNextStep: () => void;
}

const OrderSummary = ({ onOrderCreated, onNextStep }: OrderSummaryProps) => {
  const { createOrder } = useCreateOrder();
  const { getTotalPrice, getTotalDiscountAmount, packageFeeTotal } = useCart();
  const totalPrice = getTotalPrice();
  const totalDiscount = getTotalDiscountAmount();

  const onClickNextStep = async () => {
    try {
      const order = await createOrder();
      onOrderCreated({
        orderId: order.orderId,
        orderNumber: order.orderNumber,
      });
      onNextStep();
    } catch (err) {
      console.error(err);
      alert("Kunde inte skapa order");
    }
  };

  return (
    <Content className="order-summary-content">
      <Header className="order-summary-header">Summering</Header>
      <CartWrapper className="order-summary-cart-wrapper">
        <CheckoutCart />
      </CartWrapper>
      <BottomWrapper className="order-summary-bottom">
        <Summery
          totalPrice={totalPrice}
          totalDiscount={totalDiscount}
          packageFeeTotal={packageFeeTotal}
        >
          <Button as={Theme.Dark} onClick={onClickNextStep}>
            Till betalning
          </Button>
          <DiscountSection />
        </Summery>
      </BottomWrapper>
    </Content>
  );
};

const Content = styled.div({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  justifySelf: "center",
  alignItems: "center",
  padding: { x: spacing.m, y: spacing.s },
  gap: spacing.m,
});

const BottomWrapper = styled.div({
  marginTop: spacing.l,
  width: "100%",
  display: "flex",
  justifySelf: "center",
  alignItems: "center",
  flexDirection: "column",
  gap: spacing.m,
});

const CartWrapper = styled.div({});

const Header = styled.h1({
  textAlign: "center",
});

export default OrderSummary;
